"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.printTemplate = void 0;
var printTemplate = exports.printTemplate = /\$([\w.]+)/g;